module.exports = __webpack_public_path__ + "img/book-white.c4d7955d.svg";